import { CodeMaintenanceType } from 'src/constants/nacodemaintenance'
import PropTypes from 'prop-types'
import naCodeMaintenanceAutocompleteField from './NaCodeDescCodeMaintainceAutoCompleteField'

function NaCustomsOfficeAutocompleteField(props) {
  return naCodeMaintenanceAutocompleteField(
    props,
    CodeMaintenanceType.CUSTOMS_OFFICE,
  )
}

export default NaCustomsOfficeAutocompleteField